<script>
    import R, {LOADER} from "../lib/requests";
    import charges from "../stores/charges";
    import Modal from '../components/modal/Modal.svelte';
    import PriceControl from "../components/controls/PriceControl.svelte";
    import {
        copyObject,
        durationString,
        millisecondsToHours,
        formatDate,
        setFocusTo,
        validateFormData, acronym
    } from "../lib/lib";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import ChargeObject from "../components/controls/ChargeObject.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import ProjectSelectControl from "../components/controls/ProjectSelectControl.svelte";
    import {OBJECTS} from "../lib/constants";
    import ColoredAcronym from "../components/controls/ColoredAcronym.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    let charge = null;
    let chargeObject = null;
    let chargeClient = null;
    let chargeProject = null;
    let modalTitle = $charges.charge.id ? 'Χρέωση' : 'Νέα Χρέωση';
    let buttonLabel = $charges.charge.id ? 'Ενημέρωση' : 'Καταχώρηση';
    let isPaidOff = false;
    let projectId = null;


    const emptyCharge = () => {
        return {
            id: 0,
            object_type: null,
            object_id: null,
            client_id: null,
            project_id: null,
            name: '',
            price: null,
            payment: null,
            is_paid_off: 0,
            notes: null,
            payed_at: null,
        };
    }

    const initialize = () => {
        if ($charges.charge.id === 0) {
            charge = emptyCharge();
            charge.object_type = $charges.charge.object_type;
            charge.object_id = $charges.charge.object_id;
            chargeClient = $charges.charge.client || null;
            chargeProject = $charges.charge.project || null;
            setFocusTo('charge-name');
        } else {
            load();
            return;
        }


        const onSuccess = result => {
            charge = emptyCharge();
            charge.object_type = result.object_type;
            charge.object_id = result.object_id;
            charge.name = $charges.charge.name ? $charges.charge.name : result.name;
            charge.price = $charges.charge.price ? $charges.charge.price : (result.price ? parseFloat(result.price) : null);
            chargeObject = result;

            setFocusTo('charge-name');
        }

        const onFailure = err => {
            // Alert.warning("Χρέωση", err.message);
        };

        R.handle(R.charge.initialize, {
            object_type: charge.object_type,
            object_id: charge.object_id
        }, onSuccess, onFailure, LOADER.POPUP);
    }

    const load = () => {
        const onSuccess = result => {
            charge = result;
            chargeObject = charge.object;
            chargeClient = charge.client;
            chargeProject = charge.project;

            delete (charge.object);
            delete (charge.client);
            delete (charge.project);

            setFocusTo('charge-payment');
        }

        const onFailure = err => {
            Alert.warning("Χρέωση", err.message);
        };

        R.handle(R.charge.details, $charges.charge.id, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {

        const onSuccess = result => {
            charge = result;
            close(charge);
            Notifier.showMessage("Η χρέωση ενημερώθηκε");
        }

        const onFailure = err => {
            let fields = {
                name: 'Περιγραφή χρέωσης',
                price: 'Χρέωση',
                payment: 'Πληρωμή',
                payed_at: 'Ημερομηνία πληρωμής',
            }
            let prompt = '';
            let focusTo = err.params && err.params.field ? err.params.field : null;
            if (err.code === 'field_required') {
                prompt = `Το πεδίο "${fields[err.params.field]}" είναι απαιτούμενο!`;
            } else if (err.code === 'field_invalid') {
                prompt = `Το πεδίο "${fields[err.params.field]}" δεν είναι έγκυρο!`;
            }

            if (prompt) {
                Notifier.showError(prompt);
                setFocusTo(`charge-${focusTo}`);
            } else {
                Alert.warning("Χρέωση", err.message);
            }
        };

        if (chargeClient) {
            charge.client_id = chargeClient.id;
            charge.project_id = null;
        } else if (chargeProject) {
            charge.client_id = null;
            charge.project_id = chargeProject.id;
        }

        let error = validate();
        if (error) {
            Notifier.showError(error.message);
            if (error.field === 'objects') {
                setFocusTo(`charge-client`);
            } else {
                setFocusTo(`charge-${error.field}`);
            }
            return;
        }

        if (charge.price < charge.payment) {
            Notifier.showError("Η τιμή χρέωσης είναι μικρότερη από την πληρωμή!");
            setFocusTo('charge-payment');
            return;
        }

        if (charge.payed_at) {
            charge.payed_at = formatDate(charge.payed_at, 'y-m-d H:i');
        }

        let action = charge.id === 0 ? 'create' : 'edit';
        R.handle(R.charge[action], charge, onSuccess, onFailure, LOADER.POPUP);
    }

    const validate = () => {
        let data = [
            {field: 'name', validation: 'is_empty', message: "Πληκτρολογήστε μια περιγραφή για την χρέωση!"},
            {field: 'objects', validation: 'is_empty', message: "Επιλέξτε πελάτη ή project!"},
            {field: 'price', validation: 'is_number', message: "Πληκτρολογήστε τιμή για την χρέωση!"},
        ];

        return validateFormData(charge, data);
    }

    const close = (param) => {
        charge = null;

        if (param instanceof Event) {
            if ($charges.charge.closeCallback) {
                $charges.charge.closeCallback();
            }
            charges.clearEdit();
            return;
        }

        setTimeout(() => {
            if ($charges.charge.closeCallback) {
                $charges.charge.closeCallback(param);
            }
            charges.clearEdit();
        }, 200);
    }

    // const setVisibleObjects = () => {
    //     objects = [];
    //     charge.objects.map(item => {
    //         let obj = objects.find(x => x.object_type == item.object_type);
    //         if (!obj) {
    //             obj = copyObject(item);
    //             obj.count = 1;
    //             if (obj.duration) {
    //                 obj.duration = ~~obj.duration;
    //             }
    //             objects.push(obj);
    //         } else {
    //             obj.count++;
    //
    //             if (item.duration) {
    //                 obj.duration += ~~item.duration;
    //             }
    //         }
    //     });
    //     objects = objects;
    // }

    const onPayOff = () => {
        if (charge.price) {
            charge.payment = charge.price;
            charge.payed_at = formatDate(new Date(), 'y-m-d H:i');
        }
    }

    const onClientChange = ({detail}) => {
        if (detail) {
            chargeProject = null;
        }
    }

    const onProjectChange = ({detail}) => {
        if (detail) {
            chargeClient = null;
        }
    }

    initialize();

    $: {
        if (charge) {
            isPaidOff = charge.payment > 0 && charge.payment == charge.price;
            if (charge.payment) {
                if (!charge.payed_at) {
                    charge.payed_at = formatDate(new Date(), 'y-m-d H:i');
                }
            } else {
                charge.payed_at = null;
            }
        }
    }
</script>

{#if charge}
    <Modal title="{ modalTitle }" icon="flash-solid" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            {#if charge.object_type == OBJECTS.SUBSCRIPTION}
                <div class="mb-3">
                    <h2 class="h5 d-flex align-items-center gap-2 mb-2">
                        <span><AppIcon icon="service" size="20" strokeWidth="2"/></span>
                        Συνδρομή
                    </h2>
                    {#if chargeObject}
                        <ColoredAcronym acronymName={ chargeObject.ws_service.name } name={ chargeObject.name }
                                        color={ chargeObject.ws_service.color } lg/>
                    {/if}
                </div>
            {:else if charge.object_type == OBJECTS.TASK}
                <h2 class="h5 d-flex align-items-center gap-2 mb-4">
                    <span><AppIcon icon="clock" size="20" strokeWidth="2"/></span>
                    Εργασία
                </h2>
            {/if}
            <div class="form-group">
                <label>Περιγραφή</label>
                <input type="text" class="form-control" id="charge-name" bind:value="{ charge.name }" required/>
            </div>
            {#if charge.object_type != OBJECTS.SUBSCRIPTION}
                <div class="form-group">
                    {#if !chargeProject}
                        <label>Πελάτης</label>
                        <ClientControl bind:client={chargeClient} id="charge-client" on:change={ onClientChange }
                                       css="mb-1"/>
                    {/if}
                    {#if !chargeClient}
                        <label>Project</label>
                        <ProjectSelectControl bind:project={chargeProject} on:change={ onProjectChange } disabled={charge.object_type == OBJECTS.TASK}/>
                    {/if}
                </div>
            {/if}
            <hr>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label>Χρέωση</label>
                        <PriceControl id="charge-price" bind:value="{ charge.price }" required/>
                        {#if !isPaidOff}
                            <div class="btn btn-link ps-0" on:click={ onPayOff }>εξόφληση</div>
                        {/if}
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <label>Πληρωμή</label>
                        <PriceControl id="charge-payment" bind:value="{ charge.payment }"/>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label>Ημερομηνία πληρωμής</label>
                <input type="datetime-local" class="form-control" id="charge-payed_at" bind:value="{ charge.payed_at }"
                       disabled="{ !charge.payment }">
            </div>
            <div class="form-group">
                <textarea class="form-control" bind:value="{ charge.notes }" placeholder="σημειώσεις"></textarea>
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>{ buttonLabel }</button>
            </div>
        </div>
    </Modal>
{/if}